<nz-tabset>
<!--  &lt;!&ndash; Pestaña para Personas Naturales &ndash;&gt;-->
<!--  <nz-tab nzTitle="Personas Naturales">-->
<!--    <div class="search-container">-->
<!--      <input-->
<!--        nz-input-->
<!--        class="search-input"-->
<!--        placeholder="Buscar persona natural"-->
<!--        [(ngModel)]="searchNatural"-->
<!--        (input)="buscarPersonaNatural()"-->
<!--      />-->
<!--    </div>-->
<!--    <nz-table-->
<!--      class="custom-table"-->
<!--      *ngIf="personasNaturales.length > 0"-->
<!--      [nzData]="personasNaturales"-->
<!--      [nzBordered]="false"-->
<!--      [nzSize]="'middle'"-->
<!--    >-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th nzWidth="50%">Nombre</th>-->
<!--        <th nzWidth="25%">DNI</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr-->
<!--        *ngFor="let persona of personasNaturales"-->
<!--        (click)="seleccionarPersona(persona)"-->
<!--        [class.row-selected]="personaSeleccionada?.id === persona.id_persona_natural"-->
<!--        role="button"-->
<!--      >-->
<!--        <td>{{ persona.nombre_persona }}</td>-->
<!--        <td>{{ persona.dni }}</td>-->
<!--      </tr>-->
<!--      </tbody>-->
<!--    </nz-table>-->
<!--    <p *ngIf="!personasNaturales.length">No hay personas naturales disponibles.</p>-->
<!--  </nz-tab>-->

  <!-- Pestaña para Personas Jurídicas -->
  <nz-tab nzTitle="Personas Jurídicas">
    <div class="search-container">
      <input
        nz-input
        class="search-input"
        placeholder="Buscar persona jurídica"
        [(ngModel)]="searchJuridical"
        (input)="buscarPersonaJuridica()"
      />
    </div>
    <nz-table
      class="custom-table"
      *ngIf="personasJuridicas.length > 0"
      [nzData]="personasJuridicas"
      [nzBordered]="false"
      [nzSize]="'middle'"
    >
      <thead>
      <tr>
        <th nzWidth="50%">Razon Social</th>
        <th nzWidth="25%">Ruc</th>
      </tr>
      </thead>
      <tbody>
      <tr
        *ngFor="let persona of personasJuridicas"
        (click)="seleccionarPersona(persona)"
        [class.row-selected]="personaSeleccionada?.id === persona.id_persona_juridica"
        role="button"
      >
        <td>{{ persona.razon_social }}</td>
        <td>{{ persona.ruc }}</td>
      </tr>
      </tbody>
    </nz-table>
    <p *ngIf="!personasJuridicas.length">No hay personas jurídicas disponibles.</p>
  </nz-tab>
</nz-tabset>
